import { RohLink } from './types';

const LABEL: Record<string, string> = {
  objekt: 'Objekt', einheit: 'Einheit', eigentuemer: 'Eigentümer',
  mieter: 'Mieter', dienstleister: 'Dienstleister', email: 'E-Mail', ticket: 'Ticket',
};

/** Aus Sicht von `ich` die "andere Seite" eines entity_links beschreiben. null, wenn nicht beteiligt. */
export function verknuepfungAnzeige(
  link: RohLink,
  ich: { typ: string; id: string },
): { zielTyp: string; zielId: string; label: string } | null {
  if (link.source_type === ich.typ && link.source_id === ich.id) {
    return { zielTyp: link.target_type, zielId: link.target_id, label: LABEL[link.target_type] ?? link.target_type };
  }
  if (link.target_type === ich.typ && link.target_id === ich.id) {
    return { zielTyp: link.source_type, zielId: link.source_id, label: LABEL[link.source_type] ?? link.source_type };
  }
  return null;
}
